/**
 * Created by evgenijsenkevic on 23/7/25
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STICKERS_COLLECTION_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.STICKERS_COLLECTION_COLOR
    },

    STICKERS_COLLECTION_UNAVAILABLE_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.WHITE
    },

    COLLECTION_BADGE_TEXT: {
        size: 35
    },

    STICKERS_AVAILABLE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.STICKER_LABEL_COLOR
    },

    STICKERS_PROGRESS_BAR_TEXT: {
        size: 30
    },

    STICKER_JOKER_BUTTON_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    COLLECTION_WINDOW_TEXT: {
        color: cleverapps.styles.COLORS.STICKER_LABEL_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookJokerView, {
    bg: {
        width: 135,
        height: 72,
        x: { align: "right", dx: -40 },
        y: { align: "center" }
    },
    text: {
        x: { align: "center", dx: -20 },
        y: { align: "center" }
    },
    withBillet: true
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookWindow, {
    size: [
        { width: 1000, height: 1300 },
        { width: 1560, height: 1100 },
        { width: 1560, height: 1100 }
    ],

    fg: undefined,
    grid: {
        margin: {
            x: 25,
            y: 10
        },
        padding: {
            left: 20,
            bottom: 20
        }
    },

    scroll: {
        size: [
            { width: 920, height: 1120 },
            { width: 1525, height: 900 },
            { width: 1525, height: 900 }
        ],
        position: [
            { x: { align: "center" }, y: { align: "center", dy: -84 } },
            { x: { align: "center", dx: 1 }, y: { align: "center", dy: -52 } },
            { x: { align: "center", dx: 1 }, y: { align: "center", dy: -72 } }
        ]
    },

    progressView: {
        position: [
            { x: { align: "center", dx: 50 }, y: { align: "top", dy: -76 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -76 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -76 } }
        ],

        joker: [
            { x: { align: "left", dx: -50 }, y: { align: "center" } },
            { x: { align: "left", dx: -20 }, y: { align: "center" } },
            { x: { align: "left", dx: -20 }, y: { align: "center" } }
        ],

        text: {
            dy: 0
        }
    },

    collectionsAmount: {
        position: [
            { x: { align: "left", dx: 50 }, y: { align: "top", dy: -65 } },
            { x: { align: "left", dx: 50 }, y: { align: "top", dy: -65 } },
            { x: { align: "left", dx: 50 }, y: { align: "top", dy: -65 } }
        ],
        bg: {
            height: 72
        },
        text: {
            width: 120
        }
    },

    stickersAmount: {
        position: [
            { x: { align: "left", dx: 248 }, y: { align: "top", dy: -63 } },
            { x: { align: "left", dx: 280 }, y: { align: "top", dy: -63 } },
            { x: { align: "left", dx: 280 }, y: { align: "top", dy: -63 } }
        ],
        bg: {
            height: 72
        },
        text: {
            width: 120
        }
    },

    jokers: {
        position: [
            { x: { align: "right", dx: -45 }, y: { align: "top", dy: -56 } },
            { x: { align: "right", dx: -62 }, y: { align: "top", dy: -56 } },
            { x: { align: "right", dx: -62 }, y: { align: "top", dy: -56 } }
        ],
        text: {
            width: 120
        }
    },

    jokerAnimation: {
        position: {
            x: { align: "center" },
            y: { align: "bottom", dy: -250 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionIcon, {
    textBg: undefined,

    title: {
        maxWidth: 210,
        maxHeight: 50,
        x: { align: "center", dx: 5 },
        y: { align: "bottom", dy: 33 },
        unavailableOpacity: undefined
    },

    icon: {
        x: { align: "center", dx: 5 },
        y: { align: "center", dy: 40 }
    },

    badge: {
        text: false,
        x: { align: "right", dx: 3 },
        y: { align: "top", dy: 15 }
    },

    prizebar: {
        x: { align: "center", dx: 11 },
        y: { align: "center" },
        checkmark: {
            y: { align: "center", dy: -1 }
        },
        button: {
            y: { align: "center", dy: -1 }
        },
        removeBarText: true,
        width: 180
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersComponent, {
    position: [
        { x: { align: "center" }, y: { align: "center", dy: -62 } },
        { x: { align: "center" }, y: { align: "center", dy: -62 } },
        { x: { align: "center" }, y: { align: "center", dy: -60 } }
    ],
    fg: {
        size: [
            { width: 900, height: 940 },
            { width: 900, height: 940 },
            { width: 1470, height: 650 }
        ]
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionWindow, {
    size: [
        { width: 1000, height: 1200 },
        { width: 1000, height: 1200 },
        { width: 1570, height: 850 }
    ],

    prize: {
        width: 400,
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -64 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -64 } },
            { x: { align: "center" }, y: { align: "top", dy: -45 } }
        ]
    },

    finish: {
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -64 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -64 } },
            { x: { align: "center" }, y: { align: "top", dy: -45 } }
        ]
    },

    jokers: {
        position: [
            { x: { align: "right", dx: -49 }, y: { align: "top", dy: -54 } },
            { x: { align: "right", dx: -49 }, y: { align: "top", dy: -54 } },
            { x: { align: "right", dx: -56 }, y: { align: "top", dy: -33 } }
        ],
        hideOnComplete: true
    },

    text: {
        dy: 0
    },

    stamp: {
        x: { align: "right", dx: -35 },
        y: { align: "bottom", dy: 35 }
    },

    checkmark: undefined
});

cleverapps.overrideStyles(cleverapps.styles.StickersRewardWindow, {
    stickers: {
        margin: {
            x: 80,
            y: 135
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickerView, {
    label: {
        textBg: false,
        text: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 20 }
        },
        openedPosition: {
            x: { align: "center" },
            y: { align: "top", dy: -235 }
        }
    },
    image: {
        y: { align: "center", dy: 23 },
        zOrder: 11
    },
    hideLocked: true,
    frame: {
        zOrder: -1
    }
});
